// extracted by mini-css-extract-plugin
export default {"cls1":"ViewsWatcher-cls1_QWY","cls2":"ViewsWatcher-cls2_M5w ViewsWatcher-cls1_QWY"};